import styled from '@emotion/styled'
import { Container } from 'components/layout'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters'

export const ProductPickerWrapper = styled.div`
	background-image: linear-gradient(80deg, #fbf7ff, rgba(255, 255, 255, 0));
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const ProductPickerContainer = styled(Container)`
	width: 100%;
`

export const ProductPickerIcon = styled.div`
	width: 96px;
	position: relative;
	height: 96px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 24px;

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		margin-right: 0;
		svg {
			width: 75%;
		}
	}
`

export const ProductPickerTitle = styled.div`
	h1 {
		line-height: 40px;
	}

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		span {
			display: none;
		}
	}
`

export const DropdownMenu = styled.div`
	position: absolute;
	border-radius: 8px;
	box-shadow: 0 0 24px 0 rgba(89, 43, 134, 0.16);
	background-color: ${COLORS.WHITE};
	top: 60px;
	left: 0;
	z-index: 1;
	padding: 12px;
	width: 240px;
	max-height: 0;
	transition: 0.15s ease-out;
	overflow: hidden;
	visibility: hidden;

	@media only screen and (${PAGE_BREAKPOINTS.MOBILE_EXTRA_SMALL}) {
		left: -50px;
	}
`

export const DropdownButton = styled.div`
	display: inline-flex;
	align-items: center;
	cursor: pointer;

	h1 {
		color: #833ec6;
		text-decoration: underline;
	}

	svg {
		transition: 0.3s;
	}
`

export const Dropdown = styled.div<{ isOpen: boolean }>`
	position: relative;
	margin-top: 10px;

	${({ isOpen }) =>
		isOpen &&
		`
			${DropdownMenu} {
				max-height: 500px;
				transition: 0.15s ease-in;
				visibility: visible;	
			}

			${DropdownButton} {
				svg {
					transform: rotateX(180deg);
				}
			}
  `}
`

export const DropdownMenuItem = styled.a<{ isActive: boolean }>`
	padding: 12px;
	color: #0d0808;
	font-size: 18px;
	display: flex;
	cursor: pointer;
	align-items: center;
	text-decoration: none;

	> div {
		width: unset;
	}

	p {
		padding-left: 12px;
	}

	&:hover {
		text-decoration: underline;
		color: initial;
	}

	${({ isActive }) =>
		isActive &&
		`
		color: ${COLORS.DARK_ORCHID_PURPLE};

		svg {
			path {
				stroke: ${COLORS.DARK_ORCHID_PURPLE};
			}
		}
	`}
`

export const Outline = styled.div`
	border: 2px solid #833ec6;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 8px;
	border-radius: 8px;
`
